import { BOOKING_STATUS, INVITE_STATUS } from './constants';

const getJobInviteById = ({ garageInvites, jobInviteId }) =>
  garageInvites.find(({ invitationId }) => invitationId === jobInviteId);

export function getDefaultInviteId(garageInvites) {
  const relevantStatuses = [INVITE_STATUS.DRAFT, INVITE_STATUS.PENDING, INVITE_STATUS.REVIEW];
  const relevantInvites = garageInvites.filter((invite) => relevantStatuses.includes(invite.status));

  const mostRecentInvite = relevantInvites.sort((a, b) =>
    a.creationDateTime > b.creationDateTime ? -1 : 1
  )[0];

  return mostRecentInvite?.invitationId;
}

export function getJobInviteIdFromUrl(mockedInviteId) {
  if (mockedInviteId) return mockedInviteId; // Used for unit tests only due to issues mocking URLSearchParams
  const params = new URLSearchParams(window.location.search);
  return params.get('jobInvitationId');
}

const getPendingJobInviteIdToLoad = ({ hasAcceptedInvite, garageInvites, mockedInviteId }) => {
  const selectedJobInviteIdFromUrl = getJobInviteIdFromUrl(mockedInviteId);

  if (selectedJobInviteIdFromUrl) return selectedJobInviteIdFromUrl;

  if (!hasAcceptedInvite) return getDefaultInviteId(garageInvites);

  return null;
};

export const getSelectedJobInvite = ({ garageInvites, masterStatusId, mockedInviteId = undefined }) => {
  const hasAcceptedInvite =
    masterStatusId >= BOOKING_STATUS.ALLOCATED && masterStatusId <= BOOKING_STATUS.CLOSED;
  const jobInviteIdToLoad = getPendingJobInviteIdToLoad({
    hasAcceptedInvite,
    garageInvites,
    mockedInviteId,
  });
  const jobInvitation = getJobInviteById({ garageInvites, jobInviteId: jobInviteIdToLoad });
  return jobInvitation;
};

export const invitationIsReadonly = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const readonlyParam = urlParams.get('readonly');
  return readonlyParam === 'true';
};
